import React, { useState } from 'react';
import ArrowRight from './icons/ArrowRight';

import { email as emailRegex } from 'magic-tricks/lib/regex';
import cx from 'classnames';

const BackInStock = ({ variantId }) => {
  const [state, setState] = useState({
    email: '',
    isSuccess: false,
    isError: false,
    isSubmitting: false,
    showInvalidEmailError: false,
    errorMessage: null,
  });

  const onChangeEmail = event => {
    const { showInvalidEmailError } = state;
    setState({
      ...state,
      email: event.target.value,
      showInvalidEmailError: showInvalidEmailError
        ? !emailRegex.test(event.target.value)
        : showInvalidEmailError,
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setState({
      ...state,
      isSubmitting: true,
    });

    if (!state.email) {
      setState({
        ...state,
        showInvalidEmailError: false,
        isSubmitting: false,
        isError: 'Please enter your email.',
      });
      return;
    }

    if (!emailRegex.test(state.email)) {
      setState({
        ...state,
        showInvalidEmailError: true,
        errorMessage: 'Invalid email address',
        isError: false,
        isSubmitting: false,
      });

      return;
    }

    try {
      const request = await fetch('/.netlify/functions/back-in-stock', {
        method: 'POST',
        body: JSON.stringify({
          email: state.email,
          variant: variantId,
          platform: 'shopify',
        }),
      });
      await request.json();

      setState({
        ...state,
        isSubmitting: false,
        showInvalidEmailError: false,
        errorMessage: null,
        isError: false,
        isSuccess: true,
      });
    } catch (error) {
      console.error(error);
      setState({
        ...state,
        isSubmitting: false,
        showInvalidEmailError: false,
        errorMessage: 'An error has occurred. Please try again later',
        isError: true,
        isSuccess: false,
      });
    }
  };

  return (
    <div className="mt-20">
      <p className="serif--sm">Notify me when back in stock</p>

      <form className="mt-10 max-w-300" onSubmit={handleSubmit}>
        <div className="relative">
          <label>
            <input
              type="email"
              name="email"
              className="input--newsletter pr-30"
              placeholder="Email Address"
              value={state.email}
              onChange={onChangeEmail}
            />
          </label>

          <button
            type="submit"
            disabled={state.isSuccess}
            className={cx('input--newsletter__submit link--opacity', {
              loading: state.isSubmitting,
            })}
          >
            <ArrowRight />
          </button>
        </div>
        {state.showInvalidEmailError && (
          <p className="mono--md mt-10 text-[red]">{state.errorMessage}</p>
        )}
        {state.isError && (
          <p className="mono--md mt-10 text-[red]">{state.isError}</p>
        )}
        {state.isSuccess && (
          <p className="mono--md mt-10">
            We will notify you when this item gets back in stock.
          </p>
        )}
      </form>
    </div>
  );
};

export default BackInStock;
